// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme from "../../styles/Theme.bs.js";
import * as Emotion from "../../bindings/Emotion.bs.js";
import * as Belt_Option from "@rescript/runtime/lib/es6/Belt_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

let baseStyles = Emotion.Css.css({
  margin: "0",
  fontFamily: Theme.Theme.Typography.fontFamily.sans,
  lineHeight: "1.75",
  color: Theme.Theme.Colors.text.primary
});

function getVariantStyles(variant) {
  if (variant === "overline") {
    return Emotion.Css.css({
      fontSize: "0.6875rem",
      fontWeight: "500",
      lineHeight: "1.25",
      letterSpacing: "0.15em",
      textTransform: "uppercase",
      color: Theme.Theme.Colors.text.secondary
    });
  } else if (variant === "heading") {
    return Emotion.Css.css({
      fontFamily: Theme.Theme.Typography.fontFamily.serif,
      fontSize: "1.5rem",
      fontWeight: "400",
      lineHeight: "1.2",
      letterSpacing: "-0.02em"
    });
  } else if (variant === "caption") {
    return Emotion.Css.css({
      fontSize: "0.8125rem",
      fontWeight: "400",
      lineHeight: "1.5",
      color: Theme.Theme.Colors.text.secondary
    });
  } else if (variant === "display") {
    return Emotion.Css.css({
      fontFamily: Theme.Theme.Typography.fontFamily.serif,
      fontSize: "3rem",
      fontWeight: "400",
      lineHeight: "1.15",
      letterSpacing: "-0.02em"
    });
  } else {
    return Emotion.Css.css({
      fontSize: "1.0625rem",
      fontWeight: "400",
      lineHeight: "1.75"
    });
  }
}

function getSizeStyles(size) {
  if (size === "md") {
    return Emotion.Css.css({
      fontSize: "1rem"
    });
  } else if (size === "sm") {
    return Emotion.Css.css({
      fontSize: "0.875rem"
    });
  } else if (size === "xl") {
    return Emotion.Css.css({
      fontSize: "1.25rem"
    });
  } else if (size === "xs") {
    return Emotion.Css.css({
      fontSize: "0.75rem"
    });
  } else if (size === "2xl") {
    return Emotion.Css.css({
      fontSize: "1.5rem"
    });
  } else if (size === "3xl") {
    return Emotion.Css.css({
      fontSize: "1.875rem"
    });
  } else if (size === "4xl") {
    return Emotion.Css.css({
      fontSize: "2.25rem"
    });
  } else {
    return Emotion.Css.css({
      fontSize: "1.125rem"
    });
  }
}

function getWeightStyles(weight) {
  if (weight === "semibold") {
    return Emotion.Css.css({
      fontWeight: "600"
    });
  } else if (weight === "light") {
    return Emotion.Css.css({
      fontWeight: "300"
    });
  } else if (weight === "medium") {
    return Emotion.Css.css({
      fontWeight: "500"
    });
  } else if (weight === "normal") {
    return Emotion.Css.css({
      fontWeight: "400"
    });
  } else {
    return Emotion.Css.css({
      fontWeight: "700"
    });
  }
}

function getAlignStyles(align) {
  if (align === "right") {
    return Emotion.Css.css({
      textAlign: "right"
    });
  } else if (align === "justify") {
    return Emotion.Css.css({
      textAlign: "justify"
    });
  } else if (align === "center") {
    return Emotion.Css.css({
      textAlign: "center"
    });
  } else {
    return Emotion.Css.css({
      textAlign: "left"
    });
  }
}

function getTruncateStyles() {
  return Emotion.Css.css({
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  });
}

function renderTypography(variantOpt, size, weight, alignOpt, truncateOpt, color, classNameOpt, as_Opt, children, param) {
  let variant = variantOpt !== undefined ? variantOpt : "body";
  let align = alignOpt !== undefined ? alignOpt : "left";
  let truncate = truncateOpt !== undefined ? truncateOpt : false;
  let className = classNameOpt !== undefined ? classNameOpt : "";
  let as_ = as_Opt !== undefined ? as_Opt : "p";
  let textClassName = Emotion.Css.cx([
    baseStyles,
    getVariantStyles(variant),
    getAlignStyles(align),
    truncate ? getTruncateStyles() : "",
    size !== undefined ? getSizeStyles(size) : "",
    weight !== undefined ? getWeightStyles(weight) : "",
    color !== undefined ? Emotion.Css.css({
        color: color
      }) : "",
    className
  ]);
  if (as_ === "p") {
    return JsxRuntime.jsx("p", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "h1") {
    return JsxRuntime.jsx("h1", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "h2") {
    return JsxRuntime.jsx("h2", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "h3") {
    return JsxRuntime.jsx("h3", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "h4") {
    return JsxRuntime.jsx("h4", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "h5") {
    return JsxRuntime.jsx("h5", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "h6") {
    return JsxRuntime.jsx("h6", {
      children: children,
      className: textClassName
    });
  } else if (as_ === "div") {
    return JsxRuntime.jsx("div", {
      children: children,
      className: textClassName
    });
  } else {
    return JsxRuntime.jsx("span", {
      children: children,
      className: textClassName
    });
  }
}

function Typography$Typography(props) {
  let __as_ = props.as_;
  let __className = props.className;
  let __truncate = props.truncate;
  let __align = props.align;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "body";
  let align = __align !== undefined ? __align : "left";
  let truncate = __truncate !== undefined ? __truncate : false;
  let className = __className !== undefined ? __className : "";
  let as_ = __as_ !== undefined ? __as_ : "p";
  return renderTypography(variant, props.size, props.weight, align, truncate, props.color, className, as_, props.children, undefined);
}

function Typography$Typography$Display(props) {
  let __className = props.className;
  let __align = props.align;
  let __weight = props.weight;
  let __size = props.size;
  let size = __size !== undefined ? __size : "4xl";
  let weight = __weight !== undefined ? __weight : "bold";
  let align = __align !== undefined ? __align : "left";
  let className = __className !== undefined ? __className : "";
  return renderTypography("display", size, weight, align, undefined, props.color, className, "h1", props.children, undefined);
}

let Display = {
  make: Typography$Typography$Display
};

function Typography$Typography$Heading(props) {
  let __className = props.className;
  let __align = props.align;
  let __weight = props.weight;
  let __level = props.level;
  let level = __level !== undefined ? __level : "h2";
  let weight = __weight !== undefined ? __weight : "semibold";
  let align = __align !== undefined ? __align : "left";
  let className = __className !== undefined ? __className : "";
  let defaultSize = level === "h2" ? "2xl" : (
      level === "h3" ? "xl" : (
          level === "h4" ? "lg" : (
              level === "h5" ? "md" : (
                  level === "h6" ? "sm" : "3xl"
                )
            )
        )
    );
  return renderTypography("heading", Belt_Option.getWithDefault(props.size, defaultSize), weight, align, undefined, props.color, className, level, props.children, undefined);
}

let Heading = {
  make: Typography$Typography$Heading
};

function Typography$Typography$Body(props) {
  let __as_ = props.as_;
  let __className = props.className;
  let __align = props.align;
  let __weight = props.weight;
  let __size = props.size;
  let size = __size !== undefined ? __size : "md";
  let weight = __weight !== undefined ? __weight : "normal";
  let align = __align !== undefined ? __align : "left";
  let className = __className !== undefined ? __className : "";
  let as_ = __as_ !== undefined ? __as_ : "p";
  return renderTypography("body", size, weight, align, undefined, props.color, className, as_, props.children, undefined);
}

let Body = {
  make: Typography$Typography$Body
};

function Typography$Typography$Caption(props) {
  let __as_ = props.as_;
  let __className = props.className;
  let __align = props.align;
  let __weight = props.weight;
  let __size = props.size;
  let size = __size !== undefined ? __size : "sm";
  let weight = __weight !== undefined ? __weight : "normal";
  let align = __align !== undefined ? __align : "left";
  let className = __className !== undefined ? __className : "";
  let as_ = __as_ !== undefined ? __as_ : "span";
  return renderTypography("caption", size, weight, align, undefined, props.color, className, as_, props.children, undefined);
}

let Caption = {
  make: Typography$Typography$Caption
};

function Typography$Typography$Overline(props) {
  let __as_ = props.as_;
  let __className = props.className;
  let __align = props.align;
  let __weight = props.weight;
  let __size = props.size;
  let size = __size !== undefined ? __size : "xs";
  let weight = __weight !== undefined ? __weight : "medium";
  let align = __align !== undefined ? __align : "left";
  let className = __className !== undefined ? __className : "";
  let as_ = __as_ !== undefined ? __as_ : "span";
  return renderTypography("overline", size, weight, align, undefined, props.color, className, as_, props.children, undefined);
}

let Overline = {
  make: Typography$Typography$Overline
};

let Typography = {
  baseStyles: baseStyles,
  getVariantStyles: getVariantStyles,
  getSizeStyles: getSizeStyles,
  getWeightStyles: getWeightStyles,
  getAlignStyles: getAlignStyles,
  getTruncateStyles: getTruncateStyles,
  renderTypography: renderTypography,
  make: Typography$Typography,
  Display: Display,
  Heading: Heading,
  Body: Body,
  Caption: Caption,
  Overline: Overline
};

export {
  Typography,
}
/* baseStyles Not a pure module */
